module.exports = __webpack_public_path__ + "img/IO.f9469c80.png";